import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "/mnt/f/Users/sGerli/Development/rebble/rebble-store/build/sprite_module.conf.js";
var symbol = new SpriteSymbol({
  "id": "iconCalendar",
  "use": "iconCalendar-usage",
  "viewBox": "0 0 26 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 24\" id=\"iconCalendar\">\r\n  <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#000000\" transform=\"translate(2)\">\r\n    <rect width=\"20\" height=\"20\" x=\"2\" y=\"3\" fill=\"#FFFFFF\" stroke-width=\"2\" />\r\n    <polygon fill=\"#FFFFFF\" stroke-width=\"2\" points=\"2 3 22 3 20.007 13.628 18.5 20 0 19.5\" />\r\n    <polyline stroke-width=\"2\" points=\"9.219 15.076 11.722 14.81 11.781 6.924\" transform=\"rotate(52 10.5 11)\" />\r\n    <path d=\"M6.5 6.5L8.5 6.5M17.5 6.5L15.5 6.5M7.5.5L7.5 5.5M16.5.5L16.5 5.5\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/Calendar.svg
// module id = V/1g
// module chunks = 1